export default {
  failure: {
    EN: "Something went wrong. Please try again in a few minutes",
  },
};
